/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { CustomerNotificationEventEnumType } from "./CustomerNotificationEventEnum"
import { TemplateDeliveryMethodEnumType } from "./TemplateDeliveryMethodEnum"
import { TemplateReviewDecisionEnumType } from "./TemplateReviewDecisionEnum"
import { RootStoreType } from "./index"


/**
 * TemplateReviewResultPublicDtoBase
 * auto generated base class for the model TemplateReviewResultPublicDtoModel.
 */
export const TemplateReviewResultPublicDtoModelBase = ModelBase
  .named('TemplateReviewResultPublicDto')
  .props({
    __typename: types.optional(types.literal("TemplateReviewResultPublicDto"), "TemplateReviewResultPublicDto"),
    event: types.union(types.undefined, CustomerNotificationEventEnumType),
    deliveryMethod: types.union(types.undefined, TemplateDeliveryMethodEnumType),
    decision: types.union(types.undefined, TemplateReviewDecisionEnumType),
    reason: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class TemplateReviewResultPublicDtoModelSelector extends QueryBuilder {
  get event() { return this.__attr(`event`) }
  get deliveryMethod() { return this.__attr(`deliveryMethod`) }
  get decision() { return this.__attr(`decision`) }
  get reason() { return this.__attr(`reason`) }
}
export function selectFromTemplateReviewResultPublicDto() {
  return new TemplateReviewResultPublicDtoModelSelector()
}

export const templateReviewResultPublicDtoModelPrimitives = selectFromTemplateReviewResultPublicDto().event.deliveryMethod.decision.reason
